import i18n from '@/app/i18n';

/**
 * What a printed ticket shows after « Table : ». A plain number (« 12 », « T5 »,
 * « Table 7 ») stays a number; any other name is printed as the floor plan shows it.
 * Gluing the digits together printed « T1-2 » as table 12 (receipt) or 1 / 0 (kitchen):
 * the dish could go to another table. Same rule as the API (print_jobs.table_number).
 */
export const tableLabel = (name) => {
  const raw = String(name ?? '').trim();
  if (!raw) return 0;
  const m = raw.match(/^(?:t|table)?\s*(\d+)$/i);
  return m ? parseInt(m[1], 10) : raw;
};

const METHODS = [
  ['cash_amount', 'Cash'],
  ['credit_card_amount', 'Credit Card'],
  ['restaurant_ticket_amount', 'Restaurant Ticket'],
  ['other_amount', 'Other'],
];

/** True when at least one payment amount is recorded on the order. */
export const hasRecordedPayment = (order) => METHODS.some(([field]) => parseFloat(order?.[field] || 0) > 0);

/** How the order was paid, from its amounts (« Carte de crédit », « Espèces + Ticket
 * restaurant »). Falls back to « Espèces » when nothing is recorded yet. */
export const paymentLabel = (order) => {
  const used = METHODS.filter(([field]) => parseFloat(order?.[field] || 0) > 0).map(([, key]) => i18n.t(key));
  return used.length ? used.join(' + ') : i18n.t('Cash');
};
